/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";

export default styled(Switch)(({ theme, ownerState }) => {
    const { palette, functions } = theme;
    const { color, variant } = ownerState;

    const { text, gradients } = palette;
    const { linearGradient } = functions;

    // background value
    let backgroundValue;

    if (variant === "gradient") {
        backgroundValue = gradients[color]
            ? linearGradient(gradients[color].main, gradients[color].state)
            : linearGradient(gradients.info.main, gradients.info.state);
    } else {
        backgroundValue = palette[color] ? palette[color].main : palette.info.main;
    }

    return {
        "& .MuiSwitch-switchBase": {
            "&.Mui-checked": {
                color: backgroundValue,
                "& + .MuiSwitch-track": {
                    backgroundColor: `${backgroundValue} !important`,
                    opacity: 0.7,
                },
                "&.Mui-disabled + .MuiSwitch-track": {
                    opacity: 0.5,
                },
            },
            "&.Mui-disabled .MuiSwitch-thumb": {
                color: palette.grey[100],
            },
            "&.Mui-disabled + .MuiSwitch-track": {
                opacity: 0.3,
            },
        },
        "& .MuiSwitch-switchBase.Mui-checked": {
            color: backgroundValue,
            "& .MuiSwitch-thumb": {
                borderColor: 'none'
            },
        },
        // "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
        //     backgroundColor: `${backgroundValue} !important`,
        //     opacity: 0.7,
        // },
        // "& .MuiSwitch-track": {
        //     borderRadius: 26 / 2,
        //     backgroundColor: palette.grey[300],
        //     opacity: 1,
        //     borderWidth : `${0} !important`,
        //     transition: theme.transitions.create(['background-color'], {
        //         duration: theme.transitions.duration.shortest,
        //     }),
        //     boxShadow: 'rgba(0, 0, 0, 0.2) 0px 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px',
        // },
        // "& .MuiSwitch-thumb": {
        //     boxSizing: 'border-box',
        //     width: 22,
        //     height: 22,
        //     borderColor: `unset !important`,
        //     border: `none`,
        //     boxShadow: 'rgba(0, 0, 0, 0.2) 0px 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px',
        // },
    };
});
